export const PRODUCTAPPROVALREQUIRED="PRODUCTAPPROVALREQUIRED";
export const SUPPLIERIDREQUIRED="SUPPLIERIDREQUIRED";
export const COMPANYMAPPINGREQUIRED="COMPANYMAPPINGREQUIRED";
export const RENDEREXTERNALDASHBOARD = "RENDEREXTERNALDASHBOARD";
export const SLISEARCHENABLED = "SLISEARCHENABLED";